import { Injectable, Injector } from "@angular/core";
import { FirebaseCrashlytics, SetCustomKeyOptions } from '@capacitor-firebase/crashlytics';
import { FirebaseAnalytics } from '@capacitor-firebase/analytics'
import { isNativePlatform } from 'src/app/shared/utils/platform.utils';
import { NavigationEnd, Router } from "@angular/router";
import { filter } from "rxjs/operators";
import { Store } from "@ngrx/store";
import { AppState } from "../state/app.state";
import { GameState } from "../state/game/game.state";
import * as StackTrace from 'stacktrace-js';
import { BehaviorSubject, firstValueFrom } from "rxjs";
import { Analytics, isSupported, logEvent, setAnalyticsCollectionEnabled, setUserId } from "@angular/fire/analytics";


@Injectable({
    providedIn: 'root'
})
export class FirebaseReportingService {
    private _analytics: Analytics | undefined;
    private _isSuported: BehaviorSubject<null | boolean> = new BehaviorSubject(null);
    private _lastScreenName = "";
    
    constructor (
        private router: Router,
        private store: Store<AppState>,
        private injector: Injector
    ) {
        //this.initializeReporting();
    }

    private async isAnaliticsSuported(): Promise<boolean> {
        const isSupported = await firstValueFrom(this._isSuported.asObservable().pipe(filter(supported => typeof supported === 'boolean')));
        return isSupported;
    }
    
    private async initializeReporting() {
        const checkIsSupported = await isSupported();

        if (!checkIsSupported) {
            this._isSuported.next(false);
            return;
        }
        this._analytics = this.injector.get(Analytics);
        this._isSuported.next(true);
        // await FirebaseAnalytics.setEnabled({ enabled: true });
        // await FirebaseCrashlytics.setEnabled({ enabled: true });
        setAnalyticsCollectionEnabled(this._analytics, true);
        // this.subscribeToNavigation();
        // this.overrideConsoleError();
    }

    private subscribeToNavigation() {
        this.router.events.pipe(
            filter((e) => e instanceof NavigationEnd)
        ).subscribe((event: NavigationEnd) => {
            const splittedUrl: string[] = event.urlAfterRedirects.split('/');
            const screenName = this._lastScreenName = this.determineScreenName(splittedUrl);
            // FirebaseAnalytics.setCurrentScreen({screenName});
            logEvent(this._analytics, 'screen_view', {
                firebase_screen: screenName,
                firebase_screen_class: "",
            })
        });
    }

    private overrideConsoleError() {
        if (!isNativePlatform()) return;

        const _error = console.error;
        console.error = (errorMesssage: any, ...params: any[]) => {
            if (typeof errorMesssage === 'string') {
                const newError: Error = {
                    name: 'Console error',
                    message: errorMesssage
                }
                this.logError(newError);
            }
            _error(errorMesssage);
        }
    }

    private determineScreenName(splittedUrl: string[]): string {
        if (splittedUrl[1] == 'lobby') return 'lobby_' + splittedUrl[2];
        return splittedUrl[1]
    }

    async setUserId(userId: string) {
        const supported = await this.isAnaliticsSuported();

        if (!supported) return;

        // FirebaseCrashlytics.setUserId({ userId });
        // FirebaseAnalytics.setUserId({ userId });
        setUserId(this._analytics, userId);
    }

    async logEvent(eventName: string, params: Object) {
        const supported = await this.isAnaliticsSuported();

        if (!supported) return;

        // await FirebaseAnalytics.logEvent({
        //     name: eventName,
        //     params
        // });
        logEvent(this._analytics, eventName, params);
    }

    async logError(error: Error) {
        if (!isNativePlatform()) return;

        const state = await firstValueFrom(this.store);
        if (this._lastScreenName === 'game') {
            await this.setGameContext(state.game);
        }
        await this.setErrorContext(error.message, state);
        const stacktrace = await StackTrace.fromError(error);
        // await FirebaseCrashlytics.recordException({
        //     message: error.message,
        //     stacktrace
        // });
    }

    private async setGameContext(gameState: GameState) {
        const game = gameState.gamesList.find(g => g.gameStateId == gameState.selectedGame);
        if (game === undefined) return;
        const promises: Promise<any>[] = [];
        Object.keys(game).forEach(key => {
        //     promises.push(
        //         FirebaseCrashlytics.setCustomKey({
        //             key,
        //             type: 'string',
        //             value: game[key].toString()
        //         })
        //     );
        });
        return Promise.all(promises);
    }

    private setErrorContext(errorMessage: string, state: AppState) {
        const contextArray: SetCustomKeyOptions[] = [
            {
                key: 'error_message',
                type: 'string',
                value: errorMessage
            },
            {
                key: 'page_name',
                type: 'string',
                value: this._lastScreenName ? this._lastScreenName : 'page name not set'
            },
            {
                key: 'user_id',
                type: 'string',
                value: state.auth.userID ? state.auth.userID : 'user id not set'
            },
            {
                key: 'authenticated',
                type: 'boolean',
                value: state.auth.isAuthenticated
            },
            {
                key: 'club_id',
                type: 'string',
                value: state.club.id ? state.club.id : 'club id not set'
            }
        ];
        return this.sendContextArray(contextArray);
    }

    private sendContextArray(contextArray: SetCustomKeyOptions[]) {
        const promises: Promise<any>[] = [];
        for (let context of contextArray) {
            // promises.push(
            //     FirebaseCrashlytics.setCustomKey(context)
            // );
        }
        return Promise.all(promises);
    }
}